import { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  CircularProgress,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogActions,
  // Button,
} from "@mui/material";
import PaymentMethodCard from "../components/widgets/paymentmethodcard";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { GetPaymentMethods } from "../redux/slices/payment";
// import { DeletePaymentMethod } from "../redux/slices/payment";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import AddPaymentMethodCard from "../components/widgets/addpaymentmethod";
import AddPaymentMethodModal from "../components/widgets/addpaymentmethodmodal";
import DeletePaymentMethodModal from "../components/widgets/deletepaymentmethodmodal";

function PaymentMethods() {
  const { data, loading } = useSelector((state) => state.payment);
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [editingMethod, setEditingMethod] = useState(null);
  const [deletingMethod, setDeletingMethod] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    dispatch(GetPaymentMethods());
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Payment Methods
          <IconButton
            onClick={() => dispatch(GetPaymentMethods())}
            className={loading ? "animate-spin cursor-not-allowed" : ""}
            disabled={loading}
            sx={{
              backgroundColor: "#3f51b5",
              ml: 2,
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Typography>
      </Box>

      {/* Cards Grid */}
      <Grid container spacing={3}>
        {/* List Existing Payment Methods */}
        {loading ? (
          <Grid item xs={12} width={"100%"}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "20vh",
              }}
            >
              <CircularProgress />
            </Box>
          </Grid>
        ) : (
          data.map((method) => (
            <Grid item xs={12} sm={6} md={4} key={method._id}>
              <PaymentMethodCard
                method={method}
                onEdit={(m) => {
                  setEditingMethod(m);
                  setOpenAdd(true);
                }}
                onDelete={() => {
                  setDeletingMethod(method);
                  setConfirmOpen(true);
                }}
                onSetDefault={() => console.log("Set Default", method)}
              />
            </Grid>
          ))
        )}
        {/* Add Payment Method Card */}
        {!loading && (
          <Grid item xs={12} sm={6} md={4}>
            <AddPaymentMethodCard
              onClick={() => {
                setEditingMethod(null);
                setOpenAdd(true);
              }}
            />

            <AddPaymentMethodModal
              open={openAdd}
              onClose={() => {
                setOpenAdd(false);
                setEditingMethod(null);
              }}
              onCreated={() => {}}
              method={editingMethod}
              onUpdated={() => {}}
            />
          </Grid>
        )}
      </Grid>

      <DeletePaymentMethodModal
        open={confirmOpen}
        onClose={() => {
          setConfirmOpen(false);
          setDeletingMethod(null);
        }}
        method={deletingMethod}
        onDeleted={() => {
          setConfirmOpen(false);
          setDeletingMethod(null);
        }}
      />
    </Box>
  );
}

export default PaymentMethods;
